// extracted by mini-css-extract-plugin
export default {"btn--icon":"NextPreviousOpgave_btn--icon__GwtpM","btn--normal":"NextPreviousOpgave_btn--normal__ikCBq","btn--next":"NextPreviousOpgave_btn--next__ZDGCp"};